export class InputUtil {

  public static inputStyles = (styles: {} = {}) => {
    const output = {
      'display': 'block',
      'width': '100%',
      'padding': '0.75rem 1rem',
      'font-size': '1.1rem',
      'font-weight': '500',
      'line-height': '1.5',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      'appearance': 'none',
      'background-clip': 'padding-box',
      'box-shadow': 'none !important',
      'border': '1px solid #E4E6EF',
      'border-radius': '0.475rem',
      'background-color': '#F5F8FA',
      'border-color': '#F5F8FA',
      'color': '#5E6278',
      'transition': 'color 0.2s ease, background-color 0.2s ease',
      'height': '40px !important',
    };

    if (Object.keys(styles).length) {
      for (let i = 0; i < Object.keys(styles).length; i ++) {
        output[Object.keys(styles)[i]] = Object.values(styles)[i];
      }
    }

    return output;
  };
}
